import type { FileUploadEntity } from '@/shared/entities/FileUploadEntity'
import type { BranchTagTranslationEntity } from './BranchTagTranslationEntity'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'

export class CreateUpdateBranchTagEntity {
  translations?: Array<BranchTagTranslationEntity> | null
  image?: FileUploadEntity
  imageUrl?: string | null
  channel?: ChannelMiniEntity
  branches?: BranchMiniEntity[] | undefined
  isActive?: boolean
  order?: number | null
}
